<table>
	<thead>
		<tr>
			<th colspan="5">
				<div>
					<h2>{{ title }}</h2>
					<a
						*ngIf="selectedSkus.length !== ingredients?.length; else deselectAllLink"
						(click)="selectAll()"
						i18n="@@ingredientGrid-selectAll"
						>Select all</a
					>
					<ng-template #deselectAllLink>
						<a (click)="deselectAll()" i18n="@@ingredientGrid-deselectAll">Deselect all</a>
					</ng-template>
				</div>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="let ingredient of ingredients; let i = index; trackBy: trackByProductSku"
			recipe-ingredient-stamp
			[ingredientType]="gridType"
			[ingredient]="ingredient"
			[uniqueid]="ingredient.item?.sku"
			[selected]="selectedSkus.includes(ingredient.item?.sku)"
			(selectionChange)="selectionChange($event)"
			(quantityChange)="handleQuantityChanged($event)"
		></tr>
	</tbody>
</table>
